// Shared by the runtime and the initial CSS manifest so public pages select
// the same layout before hydration and during client navigation.
export function publicPageLayoutKind(name, theme) {
    if (!['Public/Catalog', 'Public/Record'].includes(name)) return null;
    return ['Pompei', 'Omnia'].includes(theme) ? 'tenant' : 'neutral';
}
